import React, { useEffect, useState } from "react";
import '../SideMenu/SideMenu.css'
//import MenuItem from '../MenuItem/MenuItem'
import MenuItemIssueDate from "./MenuItemIssueDate";

export const menuItemIssueDate = [


    {
      name: "Getting started",
      exact: true,
      to: `/gettingStartedAppIssueDates`,
      iconClassName: "bi bi-play-fill",
   
    },


    { name: "Support contacts and SLA ",
      to: `/SupportAppIssueDates`,
      iconClassName: "bi bi-wrench"
     },

    {
      name: "Data Security ",
      exact: true,      
      to: `/DataSecurityAppIssueDates`,
      iconClassName: "bi bi-shield-lock-fill",
  
    },

    { name: "End User License ", 
      to: `/EndUserLicenseAppIssueDates`,
      iconClassName: "bi bi-patch-check-fill" 
    },
    
    /*
    { name: "Video demonstration ", 
    to: `/demonstrationVideoIssueDates`,
    iconClassName: "bi bi-camera-video-fill" 
  },*/

  
  ];

const SideMenuIssueDate = (props) => {
    const [inactive, setInactive] = useState(false);
  
    useEffect(() => {
      if (inactive) {
        removeActiveClassFromSubMenu();
      }
  
      props.onCollapse(inactive);
    }, [inactive]);
  
    //just an improvment and it is not recorded in video :(
    const removeActiveClassFromSubMenu = () => {
      document.querySelectorAll(".sub-menu").forEach((el) => {
        el.classList.remove("active");
      });
    };
  
    /*just a little improvement over click function of menuItem
      Now no need to use expand state variable in MenuItem component
    */
    useEffect(() => {
      let menuItemIssueDate = document.querySelectorAll(".menu-item");
      menuItemIssueDate.forEach((el) => {
        el.addEventListener("click", (e) => {
          const next = el.nextElementSibling;
          removeActiveClassFromSubMenu();
          menuItemIssueDate.forEach((el) => el.classList.remove("active"));
          el.classList.toggle("active");
          //console.log(next);
          if (next !== null) {
            next.classList.toggle("active");
          }
        });
      });
    }, []);
  
    return (
      <div className={`side-menu ${inactive ? "inactive" : ""}`}>
        <div className="top-section">
          <div className="logo">
            logo
          </div>
          <div onClick={() => setInactive(!inactive)} className="toggle-menu-btn">
            {inactive ? (
              <i className="bi bi-arrow-right-square-fill"></i>
            ) : (
              <i className="bi bi-arrow-left-square-fill"></i>
            )}
          </div>
        </div>
  
     
        <div className="divider"></div>
  
        <div className="main-menu">
          <ul>
            {menuItemIssueDate.map((menuItem, index) => (
              <MenuItemIssueDate
                key={index}
                name={menuItem.name}
                exact={menuItem.exact}
                to={menuItem.to}
                subMenus={menuItem.subMenus || []}
                iconClassName={menuItem.iconClassName}
                onClick={(e) => {
                  if (inactive) {
                    setInactive(false);
                  }
                }}
              />
            ))}
  
            {/* <li>
              <a className="menu-item">
                <div className="menu-icon">
                  <i class="bi bi-speedometer2"></i>
                </div>
                <span>Dashboard</span>
              </a>
            </li>
            <MenuItem
              name={"Content"}
              subMenus={[{ name: "Courses" }, { name: "Videos" }]}
            />
            <li>
              <a className="menu-item">
                <div className="menu-icon">
                  <i class="bi bi-vector-pen"></i>
                </div>
                <span>Design</span>
              </a>
            </li> */}
          </ul>
        </div>
  
        <div className="side-menu-footer">
         
          <div className="user-info">
            <h5>test email</h5>
            <p>test@gmail.com</p>
          </div>
        </div>
      </div>
    );};

export default SideMenuIssueDate;
